import React from 'react';
import { Svg, Path, G, Defs, Rect, ClipPath } from "react-native-svg-web";


const SadFace = ({
  style,
  className,
  size = '30px',
  color = '#333' }) => /*#__PURE__*/

React.createElement(Svg, {
  fill: "none",
  width: size,
  height: size,
  style: style,
  viewBox: "0 0 30 31",
  className: className,
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement(G, { clipPath: "url(#clip0_9146_64)" }, /*#__PURE__*/
React.createElement(Path, {
  d: "M15.25 5.54037C9.50624 5.54037 4.85 10.1966 4.85 15.9404C4.85 21.6841 9.50624 26.3404 15.25 26.3404C20.9938 26.3404 25.65 21.6841 25.65 15.9404C25.65 10.1966 20.9938 5.54037 15.25 5.54037ZM2.25 15.9404C2.25 8.76067 8.0703 2.94037 15.25 2.94037C22.4297 2.94037 28.25 8.76067 28.25 15.9404C28.25 23.1201 22.4297 28.9404 15.25 28.9404C8.0703 28.9404 2.25 23.1201 2.25 15.9404Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M12.65 12.6904C12.65 13.7673 11.777 14.6404 10.7 14.6404C9.62304 14.6404 8.75 13.7673 8.75 12.6904C8.75 11.6134 9.62304 10.7404 10.7 10.7404C11.777 10.7404 12.65 11.6134 12.65 12.6904Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M21.75 12.6904C21.75 13.7673 20.877 14.6404 19.8 14.6404C18.723 14.6404 17.85 13.7673 17.85 12.6904C17.85 11.6134 18.723 10.7404 19.8 10.7404C20.877 10.7404 21.75 11.6134 21.75 12.6904Z",
  fill: color }), /*#__PURE__*/

React.createElement(Path, {
  d: "M20.0792 17.9731C21.0706 19.0236 21.5566 20.2065 21.7112 20.8251L19.1888 21.4557C19.1268 21.2075 18.8327 20.4405 18.1883 19.7576C17.5789 19.1118 16.6614 18.5404 15.25 18.5404C13.8386 18.5404 12.9212 19.1118 12.3117 19.7576C11.6673 20.4405 11.3732 21.2075 11.3112 21.4557L8.78883 20.8251C8.94346 20.2065 9.4294 19.0236 10.4208 17.9731C11.4472 16.8856 13.0214 15.9404 15.25 15.9404C17.4786 15.9404 19.0528 16.8856 20.0792 17.9731Z",
  fill: color })), /*#__PURE__*/


React.createElement(Defs, null, /*#__PURE__*/
React.createElement(ClipPath, { id: "clip0_9146_64" }, /*#__PURE__*/
React.createElement(Rect, {
  fill: "white",
  width: size,
  height: size,
  transform: "translate(0.25 0.940369)" }))));






export default SadFace;